import { render, staticRenderFns } from "./EVToolsLogo.vue?vue&type=template&id=4206c519"
import script from "./EVToolsLogo.vue?vue&type=script&lang=js"
export * from "./EVToolsLogo.vue?vue&type=script&lang=js"
import style0 from "./EVToolsLogo.vue?vue&type=style&index=0&id=4206c519&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports